import React from 'react';
import './InboundCallBoxAsstForm.css';
const InboundCallBoxInAsstForm = ({
  inboundCallText,
  inboundCallNumber
}: {
  inboundCallText: string | undefined;
  inboundCallNumber: string | undefined;
}) => {
  return (
    <div className="inboundCallInfoForm makeFlex">
      <div className="inboundCallTextForm font14 latoBold makeFlex  vrtlCenter2 lineHeight16">
        {inboundCallText}
      </div>
      <div className="inboundCallNumberAreaForm">
        <span className="inboundCallNumberTextForm makeFlex  vrtlCenter2 latoBold">
          {inboundCallNumber}
        </span>
      </div>
    </div>
  );
};

export default InboundCallBoxInAsstForm;
